import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h12v2.172a2 2 0 0 1 -.586 1.414l-3.914 3.914m-.5 3.5v4l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconFilterOff = createReactComponent('outline', 'filter-off', 'FilterOff', __iconNode);

export default IconFilterOff;